export default "__VITE_ASSET__e0d121f8__"